import React, { useState, useEffect } from 'react';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage2 } from "../../Firebase_Config/firebase";
import axios from 'axios';
import { Link } from 'react-router-dom';
import './tabular.css';
import { FaCloudUploadAlt } from "react-icons/fa";

const Popup = ({ message, onClose }) => {
  return (
      <div className="popup-overlay">
          <div className="popup-box">
              <p>{message}</p>
              <button className="popup-close" onClick={onClose}>Close</button>
          </div>
      </div>
  );
};

function TabularPage() {
  const [file, setFile] = useState(null);
  const [reportUrl, setReportUrl] = useState("");
  const [showButtons, setShowButtons] = useState(true);
  const [showReportLink, setShowReportLink] = useState(false);
  const [loading, setLoading] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupVisible2, setPopupVisible2] = useState(false);


  useEffect(() => {
      const checkTimeForPopup = () => {
          const now = new Date();
          const minutes = now.getMinutes();
          if (minutes === 50) {  // 10 minutes before the hour
              setPopupVisible(true);
          }
      };

      // Check every minute
      const interval = setInterval(checkTimeForPopup, 60000);
      return () => clearInterval(interval);
  }, []);
  
  useEffect(() => {
      const checkTimeForPopup2 = () => {
          const now = new Date();
          const minutes = now.getMinutes();
          if (minutes === 58) {  // 1 minutes before the hour
              setPopupVisible2(true);
          }
      };

      // Check every minute
      const interval = setInterval(checkTimeForPopup2, 60000);
      return () => clearInterval(interval);
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleFileUpload = () => {
    if (!file) return;
    setLoading(true);
    const storageRef = ref(storage2, `tabular_data/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
      },
      (error) => {
        console.error('Error uploading file:', error);
        setLoading(false);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          axios.post(' https://data-quality.assentian.com/process-file', { url: downloadURL })
            .then(response => {
              const fileBlob = new Blob([response.data], { type: 'text/html' });
              const url = window.URL.createObjectURL(fileBlob);
              setReportUrl(url);
              setLoading(false);
              setShowReportLink(true);
            })
            .catch(error => {
              console.error("There was an error processing the file!", error);
              setLoading(false);
            });
        });
      }
    );
  };

  return (
    <div className='bg'>
    <div className='tabularcontent'>
      <div className="container2">
        <div className='Pro-card-accent'/>
        <br/>
        <Link to={'/DataProfiler'}>
          <button className="submit-button">Back</button>
        </Link>
        {<img src="../Pactum.png" alt="Logo" className='profiler-image small' />}    
        {showButtons && (
          <>
            <h1 className="page-title">Upload CSV and View Profiling Report</h1>
            {/*<div className="file-upload">
              <label htmlFor="file-upload-input">Choose File</label>
              <input
                type="file"
                id="file-upload-input"
                onChange={handleFileChange}
              />
              {file && <span className="file-name">{file.name}</span>}
            </div>*/}
            <div className="form-row tabular">
              <div className="form">
                  <h1 className="main-title upload">Upload your CSV</h1>
                  <p className="form-paragraph">File should be a .csv</p>
                      <div className='drop-container'>
                          <FaCloudUploadAlt className='icon-upload'/>
                          <label className="custom-file-upload">
                              Choose File
                              <input
                              type="file"
                              id="file-upload-input"
                              name="file-upload-input"
                              onChange={handleFileChange}
                              required
                              />
                          </label>
                      </div>
                  {file && <span className="file-name">{file.name}</span>}
              </div>
            </div>
            <button className="submit-button" onClick={handleFileUpload}>Upload</button>
          </>
          
        )}
        <br/>
        {loading && <div className="loading-spinner"></div>}
        {popupVisible && <Popup message="WARNING: Application to restart in 10 minutes. Any active processes will be stopped" onClose={() => setPopupVisible(false)} />}
        {popupVisible2 && <Popup message="WARNING: Application to restart in 1 minute. Any active processes will be stopped" onClose={() => setPopupVisible2(false)} />}
        {showReportLink && (
          <div className='container2'>
            <a href={reportUrl} target="_blank" rel="noopener noreferrer">Open Profiling Report</a>
          </div>
        )}
      </div>
    </div>
    </div>
  );
}

export default TabularPage;
